import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=75071f03&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=75071f03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75071f03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75071f03')) {
      api.createRecord('75071f03', component.options)
    } else {
      api.reload('75071f03', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=75071f03&scoped=true&", function () {
      api.rerender('75071f03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contacts.vue"
export default component.exports